import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { AppAuthProvider } from "@/auth/AppAuthProvider";
import { TerminalProvider } from "@/context/TerminalContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppAuthProvider>
        <TerminalProvider>
          <App />
        </TerminalProvider>
      </AppAuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
